import _ from 'underscore';

export const getFinalUrlExpansionTitleDetails = (i18n, view, isFinalUrlExpansionEnabled) => {
  if (!view) return '';
  if (!isFinalUrlExpansionEnabled) {
    return i18n.getString(_TL_('Use the Final URL only'));
  }
  const selected = view.selectedTargetsView.viewmodel.values();
  const exactUrls = [];
  const rules = [];

  _.each(selected, (target) => {
    const conditions = target.Criterion.WebPage.Parameter.Conditions;
    _.each(conditions, (condition) => {
      if (condition.Operator === 'Equals') {
        exactUrls.push(condition.ArgumentOperand);
      } else {
        rules.push(`URL contains ${condition.ArgumentOperand}`);
      }
    });
  });

  const exactUrlsDetails = exactUrls.length > 0 ? `${i18n.getString(_TL_('Excluded URLs: '))}${exactUrls.join(', ')}` : null;
  const rulesDetails = rules.length > 0 ? `${i18n.getString(_TL_('Exclusion rules: '))}${rules.join(', ')}`:null;

  if (exactUrlsDetails && rulesDetails) {
    return `${exactUrlsDetails}; ${rulesDetails}`;
  }
  return exactUrlsDetails || rulesDetails || i18n.getString(_TL_('You’ve enabled Final URL expansion'));
};
